import { useState } from "react";
import { IListing } from "repoV2/features/Listing/Listing.interfaces";

const INITIAL_STATE = {
    open: false,
    isRebooking: false,
};

const useRebookingConfirmationModalContainer = () => {
    const [modalState, setModalState] = useState<{
        open: boolean;
        status?: number;
        errorMap?: IListing.IRebookingErrorMap;
        isRebooking?: boolean;
    }>(INITIAL_STATE);

    const openModal = (state: {
        status: number;
        errorMap: IListing.IRebookingErrorMap;
        isRebooking?: boolean;
    }) => {
        setModalState({ open: true, ...state });
    };

    const closeModal = () => {
        setModalState(INITIAL_STATE);
    };

    const handleRebookingError = ({
        response,
        isRebooking,
    }: {
        response: IListing.IRebookingError;
        isRebooking?: boolean;
    }) => {
        // todo: add dev comment why do we need to take first element (need backend inputs)
        const [errorMap] = response?.data?.error_map_list || [];
        openModal({
            isRebooking,
            errorMap,
            status: response.status,
        });
    };

    return { modalState, openModal, closeModal, handleRebookingError };
};

export default useRebookingConfirmationModalContainer;
